/** DO NOT EDIT: THIS FILE WAS AUTOMATICALLY GENERATED BY A TOOL **/
/* jshint ignore:start */
/* eslint-disable */
import options from 'config';
import {
    restAPIV4
} from '@/resources/rest_api_v4.js';

const DOMAIN = options.comments_api_url || 'https://comments.viafoura.co/v4/livecomments';

/**
 * HTTP Request
 * @method
 * @name commentsAPI#request
 * @param {string} method - http method
 * @param {string} url - url to do request
 * @param {object} parameters
 * @param {object} data - body parameters / object
 * @param {object} headers - header parameters
 * @param {object} config - extra configuration
 * @returns {Promise} promise
 */
function request(method, url, params, data, headers, config = {}) {
    return restAPIV4.register(DOMAIN).api.request({
        withCredentials: true,
        headers,
        method,
        params,
        data,
        url,
        ...config,
    });
};

/**
 *
 * @method
 * @name commentsAPI#pick
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.sectionUuid - The section identifying where the call is relative to
 * @param {string} parameters.contentContainerUuid - The content container identifying where the call is relative to
 * @param {string} parameters.contentUuid - The content identifying where the call is relative to
 * @param {object} config - extra configuration
 */
export function pick(parameters = {}, config = {}) {
    let path = '/{section_uuid}/{content_container_uuid}/comments/{content_uuid}/pick';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{section_uuid}', parameters['section_uuid']);

    path = path.replace('{content_container_uuid}', parameters['content_container_uuid']);

    path = path.replace('{content_uuid}', parameters['content_uuid']);

    return request('POST', path, params, data, headers, config);
};

/**
 *
 * @method
 * @name commentsAPI#unpick
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.sectionUuid - The section identifying where the call is relative to
 * @param {string} parameters.contentContainerUuid - The content container identifying where the call is relative to
 * @param {string} parameters.contentUuid - The content identifying where the call is relative to
 * @param {object} config - extra configuration
 */
export function unpick(parameters = {}, config = {}) {
    let path = '/{section_uuid}/{content_container_uuid}/comments/{content_uuid}/pick';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{section_uuid}', parameters['section_uuid']);

    path = path.replace('{content_container_uuid}', parameters['content_container_uuid']);

    path = path.replace('{content_uuid}', parameters['content_uuid']);

    return request('DELETE', path, params, data, headers, config);
};

/**
 * 
 * @method
 * @name commentsAPI#topCommentsExclude
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.sectionUuid - The section identifying where the call is relative to
 * @param {string} parameters.contentContainerUuid - The content container identifying where the call is relative to
 * @param {string} parameters.contentUuid - The content identifying where the call is relative to
 * @param {object} config - extra configuration
 */
export function topCommentsExclude(parameters = {}, config = {}) {
    let path = '/{section_uuid}/{content_container_uuid}/comments/{content_uuid}/top-comment';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{section_uuid}', parameters['section_uuid']);

    path = path.replace('{content_container_uuid}', parameters['content_container_uuid']);

    path = path.replace('{content_uuid}', parameters['content_uuid']);

    return request('DELETE', path, params, data, headers, config);
};

/**
 * 
 * @method
 * @name commentsAPI#topCommentsAdd
 * @param {object} parameters - method options and parameters
 * @param {string} parameters.sectionUuid - The section identifying where the call is relative to
 * @param {string} parameters.contentContainerUuid - The content container identifying where the call is relative to
 * @param {string} parameters.contentUuid - The content identifying where the call is relative to
 * @param {object} config - extra configuration
 */
export function topCommentsAdd(parameters = {}, config = {}) {
    let path = '/{section_uuid}/{content_container_uuid}/comments/{content_uuid}/top-comment';
    let data = {};
    let params = {};

    let headers = {};
    headers['Accept'] = 'application/json';

    path = path.replace('{section_uuid}', parameters['section_uuid']);

    path = path.replace('{content_container_uuid}', parameters['content_container_uuid']);

    path = path.replace('{content_uuid}', parameters['content_uuid']);

    return request('POST', path, params, data, headers, config);
};

/* jshint ignore:end */
